import { app } from 'core';
import { LoaderFullScreen } from 'ui/components';

const Loader = () => {
  const { isLoading, message } = app.hooks.useApp('loader');

  if (!isLoading) {
    return null;
  }

  return <LoaderFullScreen message={message} />;
};

export default Loader;
